<template>
    <div>
        <dynamic-form :formConfig="formConfig" v-model="form" @submit="submit"></dynamic-form>
    </div>
</template>
<script>
import '@/components/dynamic-form';
export default {
    data() {
        return {
            form: {name: "张三",gender: "0",city: {id: '110101', name: '东城区'},citys: [{id: '110101', name: '东城区'}]},
            formConfig: {
                inline: true,
                labelPosition: "right",
                labelWidth: "",
                size: "small",
                statusIcon: true,
                formItemList: [
                    {
                        span: 8,
                        type: "input",
                        key: "name",
                        label: "姓名",
                        disable: false,
                        readonly: false,
                        value: "",
                        placeholder: "请输入姓名",
                        rules: [
                            {
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            },
                            {
                                min: 1,
                                max: 8,
                                type: "string",
                                message: "长度在1~8个字符",
                                trigger: "blur"
                            },
                            {
                                pattern: "^[\\w\\u4e00-\\u9fa5-_]+$",
                                message: "正则验证失败:^[\\w\\u4e00-\\u9fa5-_]+$",
                                trigger: "blur"
                            }
                        ]
                    },
                    {
                        span: 8,
                        type: "input",
                        key: "company",
                        label: "公司",
                        disable: false,
                        readonly: false,
                        value: "上海信睿",
                        placeholder: "请输入公司",
                        rules: [
                            {
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            }
                        ]
                    },
                    {
                        span: 8,
                        type: "input",
                        key: "postion",
                        label: "职位",
                        disable: false,
                        readonly: false,
                        value: "",
                        placeholder: "请输入职位",
                        rules: [
                            {
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            }
                        ]
                    },
                    {
                        span: 8,
                        type: "switch",
                        label: "开关",
                        appearance: "switch",
                        value: false,
                        key: "reopen"
                    },
                    {
                        span: 8,
                        type: "radio",
                        label: "性别",
                        value: "",
                        button: false,
                        border: false,
                        key: "gender",
                        options: [
                            {
                                value: "1",
                                label: "男",
                                disabled: false
                            },
                            {
                                value: "0",
                                label: "女",
                                disabled: false
                            },
                            {
                                value: "01",
                                label: "女1",
                                disabled: false
                            }
                        ],
                        hidden: {reopen: false}
                    },
                    {
                        span: 8,
                        type: "radio",
                        label: "远程单选",
                        value: "",
                        button: false,
                        border: false,
                        key: "asynDic",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 8,
                        type: "select",
                        label: "下拉单选",
                        value: "",
                        disabled: false,
                        multiple: false,
                        placeholder: "请选择",
                        rules: [],
                        key: "yang",
                        options: [
                            {
                                value: "suanzao",
                                label: "蒸酸枣",
                                disabled: false
                            },
                            {
                                value: "yaogao",
                                label: "蒸羊羔",
                                disabled: false
                            },
                            {
                                value: "mantou",
                                label: "蒸馒头",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 8,
                        type: "select",
                        label: "下拉多选",
                        value: [],
                        disabled: false,
                        multiple: true,
                        placeholder: "请选择",
                        rules: [],
                        key: "yangs",
                        options: [
                            {
                                value: "suanzao",
                                label: "蒸酸枣",
                                disabled: false
                            },
                            {
                                value: "yaogao",
                                label: "蒸羊羔",
                                disabled: false
                            },
                            {
                                value: "mantou",
                                label: "蒸馒头",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 8,
                        type: "checkbox",
                        label: "多选",
                        key: "ctyy",
                        value: [],
                        border: true,
                        button: false,
                        rules: [
                            {
                            required: true,
                            message: "必填项",
                            trigger: "blur"
                            }
                        ],
                        options: [
                            {
                                value: "0",
                                label: "南昌",
                                disabled: false
                            },
                            {
                                value: "2",
                                label: "赣州",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 8,
                        type: "date",
                        value: null,
                        disabled: false,
                        rules: [
                            {
                                required: "true",
                                message: "此项为必填项"
                            }
                        ],
                        placeholder: "请选择",
                        key: "month",
                        subtype: "month",
                        label: "月份",
                        valueFormat: "yyyy-MM"
                    },
                    {
                        span: 8,
                        type: "date",
                        value: null,
                        disabled: false,
                        rules: [
                            {
                            required: "true",
                            message: "此项为必填项"
                            }
                        ],
                        placeholder: "请选择",
                        key: "date",
                        subtype: "date",
                        label: "日期",
                        valueFormat: "yyyy-MM-dd"
                    },
                    {
                        span: 8,
                        type: "date",
                        value: null,
                        disabled: false,
                        rules: [
                            {
                            required: "true",
                            message: "此项为必填项"
                            }
                        ],
                        placeholder: "请选择",
                        key: "dateTime",
                        subtype: "datetime",
                        label: "日期时间",
                        valueFormat: "yyyy-MM-dd HH:mm:ss"
                    },
                    {
                        span: 12,
                        type: "date",
                        value: null,
                        disabled: false,
                        rules: [
                            {
                                required: "true",
                                message: "此项为必填项"
                            }
                        ],
                        placeholder: "请选择",
                        key: "dateRange",
                        subtype: "daterange",
                        label: "日期范围",
                        valueFormat: "yyyy-MM-dd"
                    },
                    {
                        span: 12,
                        type: "date",
                        value: [
                            "2019-07-03 12:00:00 am",
                            "2019-07-11 12:00:00 am"
                        ],
                        disabled: false,
                        rules: [
                            {
                                required: "true",
                                message: "此项为必填项"
                            }
                        ],
                        placeholder: "请选择",
                        key: "dateTimeRange",
                        subtype: "datetimerange",
                        label: "时间范围",
                        valueFormat: "yyyy-MM-dd hh:mm:ss a"
                    },
                    {
                        span: 24,
                        type: "input",
                        key: "desc",
                        label: "描述",
                        disable: false,
                        subtype: 'textarea',
                        readonly: false,
                        value: "",
                        placeholder: "请输入描述",
                        rules: [
                            {
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            }
                        ]
                    },
                    {
                        label: '弹框单选',
                        key: 'city',
                        type: 'databox',
                        valueFileld: 'id',
                        labelFileld: 'name',
                        entityPath: "com.dst.slms.system.entity.SysAreaInfo",
                        extendParms: {queryFieldItem: 'id,number,name'},
                        multiple: false,
                        rules: {
                            required: true, message: '不能为空', trigger: 'change'
                        }
                    },
                    {
                        label: '弹框多选',
                        key: 'citys',
                        type: 'databox',
                        valueFileld: 'id',
                        labelFileld: 'name',
                        entityPath: "com.dst.slms.system.entity.SysAreaInfo",
                        extendParms: { queryFieldItem: 'id,number,name' },
                        extendSearch: [
                            {
                                property: 'name',
                                query: {
                                    type: 'group-input'
                                }
                            },
                            {
                                property: 'number',
                                query: {
                                    type: 'group-input'
                                }
                            }
                        ],
                        multiple: true,
                        clearable: true,
                        value: [],
                        rules: {
                            required: true, message: '不能为空', trigger: 'change'
                        }
                    }
                ]
            },
        }
    },
    watch: {
        'form.reopen'() {
            var column = this.formConfig.formItemList[1]
            if (this.form.reopen) {
                column.hidden = true
            } else {
                column.hidden = false
            }
        },
        'form.name'(val) {
            this.$set(this.form, 'postion', val)
        }
    },
    methods: {
        submit(v) {
            console.log(v)
        }
    }
}
</script>
